import React from "react";
import "./pickup_logistics.css";

/**
 * 🟦 PickupLogisticsCard.jsx
 * แพ็กเกจ: รหัส 320 — รถบรรทุก ≤4 ตัน (Logistics + คอก/ตู้)
 */

export default function PickupLogisticsCard({ onSelect }) {
  return (
    <div className="pkg-card pickup-logistics">
      <div className="pkg-body">
        <h3>รหัส 320 Logistics 2+ / 3+</h3>
        <p>รถบรรทุก ≤4 ตัน ต่อคอก/ตู้ สำหรับงาน Logistics</p>

        <ul className="pkg-list">
          <li>ทุนประกันภัย 100,000 – 500,000 บาท</li>
          <li>งานใหม่และต่ออายุภายในบริษัท</li>
          <li>รวมส่วนลด CCTV + App แจ้งเหตุ</li>
        </ul>

        <button className="pkg-btn" onClick={onSelect}>
          ดูรายละเอียด
        </button>
      </div>
    </div>
  );
}
